import { render, staticRenderFns } from "./BusinessContactEdit.vue?vue&type=template&id=723938b2&"
import script from "./BusinessContactEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports